import { AppErrorBoundary, clearChunkReloadFlags } from '@ps/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { Providers } from './app/providers';
import './index.css';

// The app has started, so whatever chunk failed before a reload is no
// longer failing. Clearing the marks lets the next stale deployment get
// its one retry too, instead of going straight to the error screen.
clearChunkReloadFlags();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html.');

createRoot(container).render(
  <StrictMode>
    {/* Outside the providers: a crash while they start up must still show
        something. In development the error itself is on screen, because a
        phone has no console to open. */}
    <AppErrorBoundary showDetail={import.meta.env.DEV}>
      <Providers>
        <App />
      </Providers>
    </AppErrorBoundary>
  </StrictMode>,
);
